import { ParentEvent } from "@g.frame/core";
import { Vector2, Vector3 } from "three";
import Stage from "../Stage";
import Syringes from "./Syringes";
import WipesComponent from "./WipesComponent/WipesComponent";
export default class InjectionLevel extends Stage {
    constructor(modulesProcessor, uiManager, environment, levelsManager) {
        super(modulesProcessor, uiManager, environment);
        this.modulesProcessor = modulesProcessor;
        this.uiManager = uiManager;
        this.environment = environment;
        this.levelsManager = levelsManager;
        this.currentStep = 0;
        this.showUIStep = (step) => {
            if (typeof step !== 'undefined')
                this.currentStep = step;
            switch (this.currentStep) {
                case (1): {
                    this.uiManager.hidePopUpScreen();
                    this.uiManager.hideText().then(() => {
                        this.uiManager.setText({
                            background: this.uiManager.getTextBackground({
                                size: new Vector2(.558, .16),
                                headerHeight: .06,
                            }),
                            elements: [
                                {
                                    object: this.uiManager.getTextHeader({
                                        text: 'Clean Up The Work Surface',
                                        window: {
                                            size: new Vector2(.510, .028),
                                            scale: 1,
                                            pxScale: 1
                                        }
                                    }),
                                    margin: 0.016 + 0.014
                                },
                                {
                                    object: this.uiManager.getTextBody({
                                        text: 'First, let’s clean the work surface with an alcohol wipe and allow the surface to air dry.',
                                        window: {
                                            size: new Vector2(.510, .052),
                                            scale: 1,
                                            pxScale: 2.125
                                        }
                                    }),
                                    margin: 0.084 + 0.026
                                }
                            ]
                        });
                    });
                    break;
                }
                case (2): {
                    this.uiManager.hidePopUpScreen();
                    this.uiManager.hideText().then(() => {
                        this.uiManager.setText({
                            background: this.uiManager.getTextBackground({
                                size: new Vector2(.558, .16),
                                headerHeight: .06,
                            }),
                            elements: [
                                {
                                    object: this.uiManager.getTextHeader({
                                        text: 'Prepare The Syringe',
                                        window: {
                                            size: new Vector2(.510, .028),
                                            scale: 1,
                                            pxScale: 1
                                        }
                                    }),
                                    margin: 0.016 + 0.014
                                },
                                {
                                    object: this.uiManager.getTextBody({
                                        text: 'Grab a vial, remove the cap and place it on the work surface.',
                                        window: {
                                            size: new Vector2(.510, .052),
                                            scale: 1,
                                            pxScale: 2.125
                                        }
                                    }),
                                    margin: 0.084 + 0.026
                                }
                            ]
                        });
                    });
                    break;
                }
                case (3): {
                    this.uiManager.hidePopUpScreen();
                    this.uiManager.hideText().then(() => {
                        this.uiManager.setText({
                            background: this.uiManager.getTextBackground({
                                size: new Vector2(.558, .134),
                                headerHeight: .06,
                            }),
                            elements: [
                                {
                                    object: this.uiManager.getTextHeader({
                                        text: 'Select A Needle',
                                        window: {
                                            size: new Vector2(.510, .028),
                                            scale: 1,
                                            pxScale: 1
                                        }
                                    }),
                                    margin: 0.016 + 0.014
                                },
                                {
                                    object: this.uiManager.getTextBody({
                                        text: 'Select a needle from the metal tray.',
                                        window: {
                                            size: new Vector2(.510, .026),
                                            scale: 1,
                                            pxScale: 1
                                        }
                                    }),
                                    margin: 0.084 + 0.013
                                }
                            ]
                        });
                    });
                    break;
                }
                case (4): {
                    this.uiManager.hidePopUpScreen();
                    this.uiManager.hideText().then(() => {
                        this.uiManager.setText({
                            background: this.uiManager.getTextBackground({
                                size: new Vector2(.558, .134),
                                headerHeight: .06,
                            }),
                            elements: [
                                {
                                    object: this.uiManager.getTextHeader({
                                        text: 'Select A Syringe',
                                        window: {
                                            size: new Vector2(.510, .028),
                                            scale: 1,
                                            pxScale: 1
                                        }
                                    }),
                                    margin: 0.016 + 0.014
                                },
                                {
                                    object: this.uiManager.getTextBody({
                                        text: 'Select the syringe that you will use.',
                                        window: {
                                            size: new Vector2(.510, .026),
                                            scale: 1,
                                            pxScale: 1
                                        }
                                    }),
                                    margin: 0.084 + 0.013
                                }
                            ]
                        });
                    });
                    break;
                }
                case (5): {
                    this.uiManager.hidePopUpScreen();
                    this.uiManager.hideText().then(() => {
                        this.uiManager.setText({
                            background: this.uiManager.getTextBackground({
                                size: new Vector2(.558, .186),
                                headerHeight: .06,
                            }),
                            elements: [
                                {
                                    object: this.uiManager.getTextHeader({
                                        text: 'Connect A Needle To A Syringe',
                                        window: {
                                            size: new Vector2(.510, .028),
                                            scale: 1,
                                            pxScale: 1
                                        }
                                    }),
                                    margin: 0.016 + 0.014
                                },
                                {
                                    object: this.uiManager.getTextBody({
                                        text: 'Drag and drop the needle you chose onto the syringe. Make sure to tighten the needle so that it is securely attached.',
                                        window: {
                                            size: new Vector2(.510, .078),
                                            scale: 1,
                                            pxScale: 2.625
                                        }
                                    }),
                                    margin: 0.084 + 0.039
                                }
                            ]
                        });
                    });
                    break;
                }
                case (6): {
                    this.uiManager.hidePopUpScreen();
                    this.uiManager.hideText().then(() => {
                        this.uiManager.setText({
                            background: this.uiManager.getTextBackground({
                                size: new Vector2(.558, .186),
                                headerHeight: .06,
                            }),
                            elements: [
                                {
                                    object: this.uiManager.getTextHeader({
                                        text: 'Withdraw The Medication',
                                        window: {
                                            size: new Vector2(.510, .028),
                                            scale: 1,
                                            pxScale: 1
                                        }
                                    }),
                                    margin: 0.016 + 0.014
                                },
                                {
                                    object: this.uiManager.getTextBody({
                                        text: 'Grab the syringe and push the needle through the top of the vial. Turn the vial and syringe upside down. Then, pull back on the plunger to withdraw the medication, being careful to keep the tip of the needle fully submerged in the medication.',
                                        window: {
                                            size: new Vector2(.510, .08),
                                            scale: 1,
                                            pxScale: 3.1
                                        }
                                    }),
                                    margin: 0.084 + 0.039
                                }
                            ]
                        });
                    });
                    break;
                }
                case (7): {
                    this.uiManager.hidePopUpScreen();
                    this.uiManager.hideText().then(() => {
                        this.uiManager.setText({
                            background: this.uiManager.getTextBackground({
                                size: new Vector2(.558, .16),
                                headerHeight: .06,
                            }),
                            elements: [
                                {
                                    object: this.uiManager.getTextHeader({
                                        text: 'Remove Air Bubbles',
                                        window: {
                                            size: new Vector2(.510, .028),
                                            scale: 1,
                                            pxScale: 1
                                        }
                                    }),
                                    margin: 0.016 + 0.014
                                },
                                {
                                    object: this.uiManager.getTextBody({
                                        text: 'Gently press in the plunger to push any air bubbles out of the syringe.',
                                        window: {
                                            size: new Vector2(.510, .052),
                                            scale: 1,
                                            pxScale: 2.125
                                        }
                                    }),
                                    margin: 0.084 + 0.026
                                }
                            ]
                        });
                    });
                    break;
                }
                case (8): {
                    this.uiManager.hidePopUpScreen();
                    this.uiManager.hideText().then(() => {
                        this.uiManager.setText({
                            background: this.uiManager.getTextBackground({
                                size: new Vector2(.558, .186),
                                headerHeight: .06,
                            }),
                            elements: [
                                {
                                    object: this.uiManager.getTextHeader({
                                        text: 'Prepare To Do Injection',
                                        window: {
                                            size: new Vector2(.510, .028),
                                            scale: 1,
                                            pxScale: 1
                                        }
                                    }),
                                    margin: 0.016 + 0.014
                                },
                                {
                                    object: this.uiManager.getTextBody({
                                        text: 'Now you are going to administer the injection to the cow. Turn around and you will see the cow. You need to inject her with the medicine in the designated area.',
                                        window: {
                                            size: new Vector2(.510, .078),
                                            scale: 1,
                                            pxScale: 2.625
                                        }
                                    }),
                                    margin: 0.084 + 0.039
                                }
                            ]
                        });
                    });
                    break;
                }
                case (9): {
                    this.uiManager.hidePopUpScreen();
                    this.uiManager.hideText().then(() => {
                        this.uiManager.setText({
                            background: this.uiManager.getTextBackground({
                                size: new Vector2(.558, .212),
                                headerHeight: .06,
                            }),
                            elements: [
                                {
                                    object: this.uiManager.getTextHeader({
                                        text: 'Insert The Needle',
                                        window: {
                                            size: new Vector2(.510, .028),
                                            scale: 1,
                                            pxScale: 1
                                        }
                                    }),
                                    margin: 0.016 + 0.014
                                },
                                {
                                    object: this.uiManager.getTextBody({
                                        text: 'Grab the needle and insert it into the cow, push the plunger slowly to inject the medication. \n' +
                                            'Tips: Injections should always be made in the green area on either side of the neck.',
                                        window: {
                                            size: new Vector2(.510, .104),
                                            scale: 1,
                                            pxScale: 3.5
                                        }
                                    }),
                                    margin: 0.084 + 0.052
                                }
                            ]
                        });
                    });
                    break;
                }
                case (10): {
                    this.uiManager.hidePopUpScreen();
                    this.uiManager.hideText().then(() => {
                        this.uiManager.setText({
                            background: this.uiManager.getTextBackground({
                                size: new Vector2(.558, .212),
                                headerHeight: .06,
                            }),
                            elements: [
                                {
                                    object: this.uiManager.getTextHeader({
                                        text: 'Dispose Of The Medical Waste',
                                        window: {
                                            size: new Vector2(.510, .028),
                                            scale: 1,
                                            pxScale: 1
                                        }
                                    }),
                                    margin: 0.016 + 0.014
                                },
                                {
                                    object: this.uiManager.getTextBody({
                                        text: 'Discard the needle and syringe into the yellow waste container. The yellow container is used to dispose of medical waste. Don\'t put these materials in with regular garbage.',
                                        window: {
                                            size: new Vector2(.510, .104),
                                            scale: 1,
                                            pxScale: 3.5
                                        }
                                    }),
                                    margin: 0.084 + 0.052
                                }
                            ]
                        });
                    });
                    break;
                }
                case (11): {
                    this.uiManager.hidePopUpScreen();
                    this.uiManager.hideText().then(() => {
                        this.uiManager.setText({
                            background: this.uiManager.getTextBackground({
                                size: new Vector2(.558, .134),
                                headerHeight: .06,
                            }),
                            elements: [
                                {
                                    object: this.uiManager.getTextHeader({
                                        text: 'Clean Work Surface',
                                        window: {
                                            size: new Vector2(.510, .028),
                                            scale: 1,
                                            pxScale: 1
                                        }
                                    }),
                                    margin: 0.016 + 0.014
                                },
                                {
                                    object: this.uiManager.getTextBody({
                                        text: 'Good Job! Last, let`s clean up the work surface.',
                                        window: {
                                            size: new Vector2(.510, .026),
                                            scale: 1,
                                            pxScale: 1
                                        }
                                    }),
                                    margin: 0.084 + 0.013
                                }
                            ]
                        });
                    });
                    break;
                }
            }
        };
        this.controlsPosition = {
            camera: new Vector3(3.7354738943316925, 1.8187211509738022, -11.07421596834468),
            target: new Vector3(3.7302487706130547, 1.8150963033516088, -11.074231935894554)
        };
        this.syringesComponent = new Syringes(this.modulesProcessor, this.showUIStep);
        this.wipesComponent = new WipesComponent(this.modulesProcessor);
    }
    init() {
        this.initAssets();
        this.syringesComponent.init();
        this.wipesComponent.init();
        // this.on('next_level_button', () => {
        //     console.log('next_level_inj');
        //     this.resetStage();
        //     this.fire('next_level', new ParentEvent('next_level', {level: '#TractorLevel'}));
        // });
        // this.on('restart_level', () => {
        //     this.resetStage();
        //     this.startLevel();
        //  });
    }
    showStartMessage() {
        if (this.completed) {
            this.fire('start_level', new ParentEvent('start_level'));
        }
        else {
            const pop = {
                header: 'Administer an Injection',
                body: 'In this level you are going to learn how to administer an injection. Click continue button to get started.',
                welcomeBodyRows: 3,
            };
            this.uiManager.on('first_button_click', () => {
                this.uiManager.off('first_button_click');
                this.fire('start_level', new ParentEvent('start_level'));
            });
            this.uiManager.showWelcomePopUp(pop);
        }
    }
    startLevel() {
        this.wipesComponent.off('wipe_finish');
        this.syringesComponent.off('syringe_finish');
        this.off('start_level');
        this.once('start_level', () => {
            this.showUIStep(1);
            this.wipesComponent.initWipeStage();
            this.wipesComponent.once('wipe_finish', () => {
                this.showUIStep(2);
                this.syringesComponent.vialSelectStep();
                this.syringesComponent.on('syringe_finish', () => {
                    this.showUIStep(11);
                    this.syringesComponent.resetVials();
                    this.wipesComponent.initWipeStage();
                    this.wipesComponent.once('wipe_finish', () => {
                        let allLevelsFinished = true;
                        let nextHash = '#Lobby';
                        for (const levelHash in this.levelsManager.levelList) {
                            const level = this.levelsManager.levelList[levelHash];
                            if (this !== level && levelHash !== '#Lobby') {
                                if (!level.completed) {
                                    nextHash = levelHash;
                                    allLevelsFinished = false;
                                    break;
                                }
                            }
                        }
                        this.showFinalMessage('Administer an Injection', allLevelsFinished);
                        //
                        this.on('next_level_button', () => {
                            this.off('restart_level');
                            this.off('next_level_button');
                            this.resetStage();
                            this.fire('next_level', new ParentEvent('next_level', { level: nextHash }));
                        });
                        this.on('restart_level', () => {
                            this.off('restart_level');
                            this.off('next_level_button');
                            this.resetStage();
                            this.startLevel();
                        });
                    });
                });
            });
        });
        this.showStartMessage();
    }
    initAssets() {
        this.addObject(this.syringesComponent);
        this.addObject(this.wipesComponent);
    }
    resetStage() {
        this.off('restart_level');
        this.off('next_level_button');
        this.uiManager.off('first_button_click');
        this.syringesComponent.resetStage();
        this.wipesComponent.reset();
    }
}
